// extracted by mini-css-extract-plugin
export var certificate = "about-module--certificate--9dgfo";
export var certificatesContainer = "about-module--certificatesContainer--zN9Ro";
export var goalContainer = "about-module--goalContainer--MUgSp";
export var goalImage = "about-module--goalImage--ThVat";
export var lightbox = "about-module--lightbox--v0rBh";